var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.telescopeUrl,"width":"100%","height":_vm.height,"frameborder":"0"},on:{"load":_vm.load}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }